import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

const SidebarNav = ({
    items = [],
    vertical = true,
    variant = 'pills',
    activeKey,
    onSelect,
    isMobile = false,
    isTablet = false,
    isDesktop = false,
    style,
    className,
    ...props
}) => {
    console.log("items :", items);
    const location = useLocation();
    const [openKeys, setOpenKeys] = useState(new Set());

    const computedItems = useMemo(() => {
        const pathname = location?.pathname || '';
        console.log("pathname :", pathname);

        const annotate = (arr) => {
            return (arr || []).map((it) => {
                const hasChildren = Array.isArray(it.children) && it.children.length > 0;
                const children = hasChildren ? annotate(it.children) : [];
                const childActive = children.some((c) => c.active);
                const normalize = (p) => {
                    if (typeof p !== 'string') return '';
                    if (p.length > 1 && p.endsWith('/')) return p.replace(/\/+$/, '');
                    return p;
                };
                const currentPath = normalize(pathname);
                const linkPath = normalize(it.link || it.href);
                const selfActive = !!(linkPath && (currentPath === linkPath || currentPath.startsWith(linkPath + '/')));
                console.log("pathname it :", it);
                console.log("pathname selfActive :", selfActive);
                console.log("pathname childActive :", childActive);
                return {
                    ...it,
                    children,
                    active: !!(selfActive || childActive)
                };
            });
        };

        return annotate(items);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items, location?.pathname]);

    useEffect(() => {
        const initialOpen = new Set();
        const shouldOpen = (item) => {
            if (!item) return false;
            if (item.active) return true;
            if (activeKey && (item.key === activeKey || item.eventKey === activeKey)) return true;
            if (Array.isArray(item.children)) {
                return item.children.some((child) => shouldOpen(child));
            }
            return false;
        };
        computedItems.forEach((it) => {
            if (Array.isArray(it.children)) {
                // Open only if this group (or its descendants) are active
                if (shouldOpen(it)) {
                    const groupKey = `grp:${it.key || it.eventKey}`;
                    initialOpen.add(groupKey);
                }
            }
        });
        setOpenKeys(initialOpen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.pathname]);

    const toggleOpen = (key) => {
        setOpenKeys((prev) => {
            const isCurrentlyOpen = prev.has(key);
            // Accordion behavior: open only the clicked group, close others
            if (isCurrentlyOpen) {
                return new Set();
            }
            const next = new Set();
            next.add(key);
            return next;
        });
    };

    const Caret = ({ open }) => (
        <span style={{ marginLeft: 'auto', transition: 'transform 0.2s ease', transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}>▶</span>
    );

    const BadgeEl = ({ item }) => (
        item.badge ? (
            <span
                style={{
                    marginLeft: 'auto',
                    padding: '2px 8px',
                    fontSize: '11px',
                    borderRadius: '10px',
                    backgroundColor: item.badgeColor || '#007bff',
                    color: 'white'
                }}
            >
                {item.badge}
            </span>
        ) : null
    );

    const renderItem = (item, depth = 0, idxPath = '0') => {
        if (item.divider) {
            return (
                <hr
                    key={`div-${idxPath}`}
                    style={{ margin: '5px 0px 10px 0px', borderColor: '#dee2e6' }}
                />
            );
        }
        if (item.header) {
            return (
                <div
                    key={`hdr-${idxPath}`}
                    style={{
                        padding: '-2px 15px',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#6c757d',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                    }}
                >
                    {item.header}
                </div>
            );
        }

        const hasChildren = Array.isArray(item.children) && item.children.length > 0;
        const key = item.key || item.eventKey || `key-${idxPath}`;
        const groupKey = `grp:${key}`;
        const isOpen = hasChildren && openKeys.has(groupKey);

        if (hasChildren) {
            return (
                <div key={`grp-${idxPath}`}>
                    <Nav.Item>
                        <Nav.Link
                            eventKey={key}
                            onClick={(e) => {
                                e.preventDefault();
                                toggleOpen(groupKey);
                            }}
                            disabled={item.disabled}
                            active={item.active || isOpen}
                            style={{
                                display: 'flex',
                                color: '#d7dee5',
                                marginRight: '20px',
                                alignItems: 'center',
                                gap: '10px',
                                padding: '10px 15px',
                                borderRadius: '5px',
                                marginBottom: '4px',
                                transition: 'all 0.2s ease',
                                paddingLeft: `${15 + depth * 15}px`,
                                ...(item.style || {})
                            }}
                        >
                            {item.icon && (
                                item.icon_type === "icon" ? (
                                    <i className={item.icon} style={{ fontSize: '18px' }}></i>
                                ) : (
                                    <img src={item.icon} alt={item.label} style={{ width: '24px', height: '24px' }} />
                                )
                            )}
                            <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.label || item.text || item.title}</span>
                            {item.badge ? <BadgeEl item={item} /> : <Caret open={isOpen} />}
                        </Nav.Link>
                    </Nav.Item>
                    {isOpen && (
                        <div style={{ marginLeft: 0 }}>
                            {item.children.map((child, cidx) => renderItem(child, depth + 1, `${idxPath}-${cidx}`))}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <Nav.Item key={`itm-${idxPath}`}>
                <Link
                    to={item.link || item.href}
                    onClick={() => onSelect && onSelect(key)}
                    className={`nav-link ${item.active ? 'active' : ''} ${item.disabled ? 'disabled' : ''}`}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginRight: '20px',
                        gap: '10px',
                        padding: '12px 15px',
                        marginLeft: '0px',
                        borderRadius: '5px',
                        marginBottom: '4px',
                        transition: 'all 0.2s ease',
                        paddingLeft: `${15 + depth * 15}px`,
                        ...(item.style || {})
                    }}
                >
                    {item.icon && (
                        item.icon_type === "icon" ? (
                            <i className={item.icon} style={{ fontSize: '18px' }}></i>
                        ) : (
                            <img src={item.icon} alt={item.label} style={{ width: '24px', height: '24px' }} />
                        )
                    )}
                    <span style={{ maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.label || item.text || item.title}</span>
                    <BadgeEl item={item} />
                </Link>
            </Nav.Item>
        );
    };

    return (
        <Nav
            className={`flex-column ${className || ''}`}
            variant={variant}
            activeKey={activeKey}
            onSelect={onSelect}
            style={style}
            {...props}
        >
            {computedItems.map((item, index) => renderItem(item, 0, String(index)))}
        </Nav>
    );
};

export default SidebarNav;

